/**
 * @version 1.0.1
 * @author wuwg  <wuwg@thunisoft.com>
 * @createTime:2019-08-13,
 * @updateTime:2019-08-13
 * @copyright thunisoft fd
 * @description  *  [jsDoc中文文档]{@link  http://www.dba.cn/book/jsdoc/JSDOCKuaiBiaoQianBLOCKTAGS/CONSTRUCTS.html}
 *  [jsdoc-vuejs]{@link  http://npm.taobao.org/package/jsdoc-vuejs}  -
 *  [个人博客]{@link  http://www.wuweigang.com}
 */
export default {
    name: 'kyxx',
    data() {
        return {
            // 搜索条件
            searchList: {
                cbky: [
                    {
                        name: '发布法院',
                        key: 'fydm',
                        list: [
                            {name: '全部', key: ''},
                            {name: '大连海事法院', key: '732'},
                            {name: '天津海事法院', key: '72'},
                            {name: '青岛海事法院', key: '2010'},
                            {name: '南京海事法院', key: '1151'},
                            {name: '上海海事法院', key: '1129'},
                            {name: '武汉海事法院', key: '2367'},
                            {name: '宁波海事法院', key: '1402'},
                            {name: '厦门海事法院', key: '1693'},
                            {name: '广州海事法院', key: '2701'},
                            {name: '北海海事法院', key: '2878'},
                            {name: '海口海事法院', key: '2925'}
                        ]
                    },
                    {
                        name: '扣押状态',
                        key: 'kyzt',
                        list: [
                            {name: '全部', key: ''},
                            {name: '扣押', key: '1'},
                            {name: '部分解扣', key: '2'},
                            {name: '解扣', key: '3'}
                        ]
                    }
                ],
                qtky: [
                    {
                        name: '扣押法院',
                        key: 'fydm',
                        list: [
                            {name: '全部', key: ''},
                            {name: '北海海事法院', key: '2878'},
                            {name: '海口海事法院', key: '2925'},
                            {name: '厦门海事法院', key: '1693'},
                            {name: '武汉海事法院', key: '2367'},
                            {name: '上海海事法院', key: '1129'},
                            {name: '广州海事法院', key: '2701'},
                            {name: '宁波海事法院', key: '1402'},
                            {name: '青岛海事法院', key: '2010'},
                            {name: '大连海事法院', key: '732'},
                            {name: '天津海事法院', key: '72'},
                            {name: '南京海事法院', key: '1151'}
                        ]
                    },
                    {
                        name: '扣押状态',
                        key: 'kyzt',
                        list: [
                            {name: '全部', key: ''},
                            {name: '扣押', key: '1'},
                            {name: '部分解扣', key: '2'},
                            {name: '解扣', key: '3'}
                        ]
                    },
                    {
                        name: '标的物类型',
                        key: 'bdlb',
                        list: [
                            {name: '全部', key: ''},
                            {name: '船载货物', key: '2'},
                            {name: '海域使用权', key: '3'},
                            {name: '土地', key: '4'},
                            {name: '房地产', key: '5'},
                            {name: '汽车', key: '6'},
                            {name: '股权', key: '7'},
                            {name: '知识产权', key: '8'},
                            {name: '其他', key: '255'}
                        ]
                    }
                ]
            },
            searchData: {
                fydm: '',
                kyzt: '',
                cblx: '',
                bdlb: '1'
            },
            total: null,
            data: {data:[]}
        };
    },
    props:{
        activeKylx:{
            type:String,
            default:''
        }
    },
    watch: {
        activeKylx:{
            handler() {
                this.init();
            },
            immediate:true
        }
    },
    methods: {
        init() {
            this.changeKylx(this.activeKylx);
        },
        // 切换拍卖类型
        changeKylx(code) {
            this.activeKylx = code;
            this.data = {data:[]};
            if (code === 'cbky') {
                this.searchData = {
                    fydm: '',
                    kyzt: '',
                    cblx: '',
                    bdlb: '1'
                };
            } else {
                this.searchData = {
                    fydm: '',
                    kyzt: '',
                    cblx: '',
                    bdlb: ''
                };
            }
            this.getKyxx();
        },
        // 切换筛选条件
        clickSearch(key, key01) {
            this.searchData[key] = key01;
            this.getKyxx();
        },
        // 点击跳转详情
        clickXq(item) {
            const routeUrl = this.$router.resolve({path: '/kypm/kyxq', query: {bh: item.bh, bdlb: item.bdlb, lx: '20'}});
            window.open(routeUrl.href, '_blank');
        },
        // 获取扣押信息
        getKyxx(queryInfo) {
            let params = this.searchData;
            if (queryInfo) {
                params = {
                    ...queryInfo,
                    ...params
                };
            }
            window.fdGlobal.ajax({
                method: window.fdConfig.methodGet,
                url: window.fdConfig.url.kypm.kyxx,
                params: params
            }).then((res) => {
                this.data = res.data;
            });
        }
    }
};

